export default "__VITE_ASSET__f1a98aab__"